import React from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';
import { useLanguage } from '../contexts/LanguageContext';
import { getTranslation } from '../utils/translations';
import { Card, Button } from '../components/UI';

const ShiftForm = () => {
  const navigate = useNavigate();
  const { language } = useLanguage();
  const t = (key) => getTranslation(language, key);

  return (
    <Layout>
      <div className="max-w-4xl mx-auto">
        <Card>
          <div className="mb-6">
            <h1 className="text-3xl font-bold mb-2">{t('postShift')}</h1>
            <p className="text-gray-600">{t('publishNewShift')}</p>
          </div>

          <div className="text-center py-12">
            <div className="text-6xl mb-6">🚧</div>
            <h2 className="text-2xl font-semibold mb-4">Phase 2 Feature</h2>
            <p className="text-gray-600 mb-8">
              Shift posting form with ToS selection, pay calculation, escrow simulation, and all business rules will be implemented in Phase 2.
            </p>
            <Button onClick={() => navigate('/liberado-jefe-clinic/dashboard')}>
              {t('back')}
            </Button>
          </div>
        </Card>
      </div>
    </Layout>
  );
};

export default ShiftForm;